<template>
  <div id="posRoles">

    <PageTitle :title="$t('pos_roles.title')" :subtitle="$t('pos_roles.description')">
      <button class="btn btn-primary" @click="newRole">{{$t('pos_roles.new')}}</button>
    </PageTitle>

    <PageContainer>

      <Empty v-if="roles.length === 0" :text="$t('pos_roles.empty')" :button="{text: $t('pos_roles.new'), action: newRole}"></Empty>

      <table class="table" v-if="roles.length > 0">
        <tr>
          <th class="icon"></th>
          <th class="name">{{$t('pos_roles.name')}}</th>
          <th class="action"></th>
        </tr>
        <tr v-for="(role, roleIndex) of roles" :key="'role-' + roleIndex">
          <td class="icon">
            <div class="table__icon">
              <svgicon src="icon/employee.svg" :height="16" :width="16"></svgicon>
            </div>
          </td>
          <td class="name">{{role.name}}</td>
          <td class="menu-items">
            <div class="actions">
              <ActionMenu icon="/icon/actions-horizontal.png">
                <div class="item" @click="editRole(role)">{{$t('edit')}}</div>
                <div class="item" @click="removeRole(roleIndex, role)">{{$t('remove')}}</div>
              </ActionMenu>
            </div>
          </td>
        </tr>
      </table>

    </PageContainer>

    <PageFooter></PageFooter>

  </div>
</template>

<script>
  import PageTitle from "@/components/PageTitle";
  import PageContainer from "@/components/PageContainer";
  import PageFooter from "@/components/PageFooter";
  import ActionMenu from "@/components/tools/ActionMenu";
  import Empty from "@/components/tools/Empty";
  import {mapActions} from "vuex";

  export default {
    name: "posRoles",

    components: { PageTitle, PageContainer, PageFooter, ActionMenu, Empty },

    data() {
      return {
        roles: []
      };
    },

    computed: {
      branchId() {
        return this.$route.query.branch;
      },
      companyId() {
        return this.$route.query.company;
      }
    },

    async mounted() {
      showSpinner();
      await this.loadRoles();
      hideSpinner();
    },

    methods: {
      ...mapActions(["getPosRoles", "deletePosRole"]),

      async loadRoles() {
        let response = await this.getPosRoles(this.companyId);
        if (response && response.posRoles) {
          this.roles = response.posRoles;
        }
      },

      editRole(role) {
        this.$router.push(this.$router.buildContext("/role/edit", {id: role.id}));
      },
      async removeRole(index, role) {
        let confirm = await showConfirmation(this.$t("warning"), this.$t("pos_roles.delete_confirmation").replace("{ROLE}", role.name));
        if (!confirm) {
          return;
        }
        showSpinner();
        let response = await this.deletePosRole(role.id);
        hideSpinner();
        if (response) {
          toast(this.$t('pos_roles.delete_success'), "success", this.$t("success"));
          this.roles.splice(index, 1);
        } else {
          toast(this.$t('pos_roles.delete_error'), "error", this.$t("error.title"));
        }
      },
      newRole() {
        this.$router.push(this.$router.buildContext("/role/new"));
      }
    }
  }
</script>

<style lang="scss" scoped>
  #posRoles {
    display: flex;
    flex-direction: column;

    .name {
      font-weight: 600;
    }

    .table {
      width: 100%;

      tr {
        &:not(:last-child) {
          td, th {
            border-bottom: 1px solid #e6e6e6;
          }
        }
      }

      td, th {
        &.icon {
          width: 1px;
        }
        &.name {
          width: 99%;
        }
      }

      th {
        text-align: left;
        font-size: 14px;
        padding-bottom: 16px;
      }

      td {
        padding-top: 16px;
        padding-bottom: 16px;
        &:first-child {
          padding-left: 16px;
        }
        &:last-child {
          padding-right: 16px;
        }
      }
      .actions {
        height: 32px;
        width: 100%;
      }
      .table__icon {
        height: 32px;
        width: 32px;
        display: flex;
        border-radius: 6px;
        background-color: #f5f5f5;
        align-items: center;
        justify-content: center;
        fill: #ccc;
        margin-right: 16px;
      }
    }

    @media screen and (max-width: 500px) {
      td, th {
        &.icon {
          display: none;
        }
      }
    }
  }
</style>